/*
 * Author: Roger
 * File Created: Wednesday, 24-09-25 11:11 am
 * Last Modified: Tuesday, 25-07-01 06:27 pm, by Ben Zhao
 */

import type { CustomAxiosRequestConfig } from '@web/http';
import { get, post } from '@web/http';

import type {
  ReferralConfig,
  RewardType,
  TypeAccountManagementFee,
  UserBoostProgress,
  UserDailyRebate,
  UserMonthRebate,
  UserRebateDashboard,
  UserRebateRate,
  UserRebateSummary,
} from '@/@types/marketing';

export const getUserRebateRate = async () => {
  return get<UserRebateRate>(`/gateway/marketing/private/v1/rebate-rate`);
};

export const getUserRebateDashboard = async () => {
  return get<UserRebateDashboard>(
    `/gateway/marketing/private/v1/rebate-dashboard`,
  );
};

export const getUserBoostProgress = async () => {
  return get<UserBoostProgress>(
    `/gateway/marketing/private/v1/rebate-current-boost`,
  );
};

export const getUserDailyRebates = async (_params: {
  rewardType: RewardType;
}) => {
  return post<UserDailyRebate[]>(
    `/gateway/marketing/private/v1/user-daily-reward`,
    _params,
  );
};

export const getUserMonthRebates = async (_params: {
  rewardType: RewardType;
}) => {
  return post<UserMonthRebate[]>(
    `/gateway/marketing/private/v1/user-reward-distribution-record-list`,
    _params,
  );
};

export const getUserRebateSummary = async () => {
  return get<UserRebateSummary>(
    `/gateway/marketing/private/v1/user-reward-summary`,
  );
};

export const getUserRebateSummaryServerSide = (
  req?: CustomAxiosRequestConfig['req'],
) => {
  return get<UserRebateSummary>(
    `/gateway/marketing/private/v1/user-reward-summary`,
    {},
    {
      req,
    },
  );
};

export const getUserReferralConfig = async () => {
  return get<ReferralConfig>(
    '/gateway/marketing/private/v1/referral-dashboard',
  );
};

export const getUserReferralConfigServerSide = (
  req?: CustomAxiosRequestConfig['req'],
) => {
  return get<ReferralConfig>(
    `/gateway/marketing/private/v1/referral-dashboard`,
    {},
    {
      req,
    },
  );
};

export const getAccountManagementFee = () => {
  return get<TypeAccountManagementFee>(
    '/gateway/marketing/private/v1/account-management-fee/detail',
  );
};

export const updateReminderStatus = (params?: {
  consumptionReminderShown?: number;
  targetAchievedReminderShown?: number;
}) => {
  return post(
    '/gateway/marketing/private/v1/account-management-fee/update-reminder-status',
    params,
  );
};

/** 获取用户邀请所有用户的记录 */
export const getReferralRecords = () => {
  return get<API.Marketing.GetReferralInviteRecordListV1Response>(
    '/gateway/marketing/private/v1/referral-invite-record-list',
  );
};

/** 提醒被邀请人 */
export const remindReferraler = (
  params: API.Marketing.PostReferralRemindV1Request,
) => {
  return post<API.Marketing.PostReferralRemindV1Response>(
    '/gateway/marketing/private/v1/referral-remind',
    params,
  );
};
